import { render, staticRenderFns } from "./goodSearchCategoryList.vue?vue&type=template&id=624e1f76&scoped=true"
import script from "./goodSearchCategoryList.vue?vue&type=script&lang=js"
export * from "./goodSearchCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e1f76",
  null
  
)

export default component.exports